var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-form",
    {
      ref: "eleBillForm",
      staticClass: "step4CnCom",
      attrs: {
        "label-width": "120px",
        rules: _vm.eleBillFormRule,
        model: _vm.eleBillForm,
      },
    },
    [
      _c(
        "div",
        { staticClass: "cainiao pddTab" },
        [
          _c(
            "el-tabs",
            {
              staticClass: "taobao",
              attrs: { stretch: true },
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "淘宝店铺账号授权", name: "shop" } },
                [
                  _vm.activeName == "shop"
                    ? [
                        _c("div", { staticClass: "tab-header" }, [
                          _c("div", { staticClass: "left-c" }, [
                            _c("img", {
                              staticClass: "icon-company-box",
                              attrs: {
                                src: require("@/assets/images/ecommercepng/icon_dianpu_TAOBAO.png"),
                                alt: "",
                              },
                            }),
                          ]),
                        ]),
                        _vm.tbShopList.length > 0 ||
                        (_vm.tbShopList.length <= 0 && _vm.loading)
                          ? _c(
                              "div",
                              { staticClass: "tab-bottom" },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: { label: "淘宝店铺", prop: "shop" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "y-f" },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              placeholder: "请选择店铺类型",
                                            },
                                            on: { change: _vm.changeShop },
                                            model: {
                                              value: _vm.eleBillForm.shop,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.eleBillForm,
                                                  "shop",
                                                  $$v
                                                )
                                              },
                                              expression: "eleBillForm.shop",
                                            },
                                          },
                                          _vm._l(
                                            _vm.tbShopList,
                                            function (item) {
                                              return _c("el-option", {
                                                key: item.id,
                                                attrs: {
                                                  label: item.MallName,
                                                  value: item.id,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "y-ml-10 y-fc-4C84FF y-c-p y-w-100",
                                            on: {
                                              click: function ($event) {
                                                return _vm.storeAuthorization(
                                                  "TAOBAO"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("添加新店铺")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "网点发货地址",
                                      prop: "faceId",
                                    },
                                  },
                                  [
                                    _vm.filterOriginList.length > 0 ||
                                    (_vm.filterOriginList.length <= 0 &&
                                      _vm.loading)
                                      ? _c(
                                          "div",
                                          { staticClass: "y-f" },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  placeholder: "请选择发货地址",
                                                },
                                                on: {
                                                  change: _vm.changeAddress,
                                                },
                                                model: {
                                                  value: _vm.eleBillForm.faceId,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.eleBillForm,
                                                      "faceId",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "eleBillForm.faceId",
                                                },
                                              },
                                              _vm._l(
                                                _vm.filterOriginList,
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item.id,
                                                    attrs: {
                                                      label: item.addressInfo,
                                                      value: item.id,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "y-ml-10 y-fc-4C84FF y-c-p y-w-100",
                                                on: { click: _vm.jumpTb },
                                              },
                                              [_vm._v("添加新发货地址")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass: "y-bk-fff6a0",
                                            staticStyle: { padding: "5px" },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "y-fl-18",
                                                staticStyle: { margin: "0" },
                                              },
                                              [
                                                _vm._v(
                                                  "未找到电子面单发货地址,当前店铺可能未开通电子面单服务或未绑定电子面单帐号。"
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                  ]
                                ),
                                _vm.filterOriginList.length <= 0 && !_vm.loading
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "y-fc-4C84FF y-c-p y-f-r y-fs-14",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { on: { click: _vm.jumpTb } },
                                          [_vm._v("开通电子面单")]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "y-ml-10",
                                            on: {
                                              click: function ($event) {
                                                return _vm.storeAuthorization(
                                                  "TAOBAO"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("绑定电子面单账号")]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "y-ml-10",
                                            on: {
                                              click: function ($event) {
                                                return _vm.howHelpAuth("TAOBAO")
                                              },
                                            },
                                          },
                                          [_vm._v("查看教程")]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _c(
                              "div",
                              { staticClass: "tab-bottom y-fs-14 clearfix" },
                              [
                                _c("p", { staticClass: "y-fc-000 y-fl-18" }, [
                                  _vm._v(
                                    " 您还未绑定任何淘宝店铺，请点击<去绑定>绑定您的淘宝店铺，或点击<查看教程>，按步骤进行操作。 "
                                  ),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "y-fc-4C84FF y-c-p y-f-r" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.storeAuthorization(
                                              "TAOBAO"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("去绑定")]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "y-ml-10",
                                        on: {
                                          click: function ($event) {
                                            return _vm.howHelpAuth("TAOBAO")
                                          },
                                        },
                                      },
                                      [_vm._v("查看教程")]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "1688账号授权", name: "ali_1688" } },
                [
                  _vm.activeName == "ali_1688"
                    ? [
                        _c("div", { staticClass: "tab-header" }, [
                          _c("div", { staticClass: "left-c" }, [
                            _c("img", {
                              staticClass: "icon-company-box",
                              attrs: {
                                src: require("@/assets/images/ecommercepng/icon_dianpu_ALI_1688.png"),
                                alt: "",
                              },
                            }),
                          ]),
                        ]),
                        Object.keys(_vm.aliShopObj).length > 0 ||
                        (Object.keys(_vm.aliShopObj).length <= 0 && _vm.loading)
                          ? _c(
                              "div",
                              { staticClass: "tab-bottom" },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: { label: "1688账号", prop: "shop" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "y-f" },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              placeholder: "请选择账号",
                                            },
                                            on: { change: _vm.changeShop },
                                            model: {
                                              value: _vm.eleBillForm.shop,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.eleBillForm,
                                                  "shop",
                                                  $$v
                                                )
                                              },
                                              expression: "eleBillForm.shop",
                                            },
                                          },
                                          _vm._l(
                                            _vm.aliShopObj,
                                            function (val, key) {
                                              return _c("el-option", {
                                                key: key,
                                                attrs: {
                                                  label: val,
                                                  value: key,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "y-ml-10 y-fc-4C84FF y-c-p y-w-100",
                                            on: {
                                              click: function ($event) {
                                                return _vm.storeAuthorization(
                                                  "ALI_1688"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("添加新账号")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "网点发货地址",
                                      prop: "faceId",
                                    },
                                  },
                                  [
                                    _vm.filterOriginList.length > 0 ||
                                    (_vm.filterOriginList.length <= 0 &&
                                      _vm.loading)
                                      ? _c(
                                          "div",
                                          { staticClass: "y-f" },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  placeholder: "请选择发货地址",
                                                },
                                                on: {
                                                  change: _vm.changeAddress,
                                                },
                                                model: {
                                                  value: _vm.eleBillForm.faceId,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.eleBillForm,
                                                      "faceId",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "eleBillForm.faceId",
                                                },
                                              },
                                              _vm._l(
                                                _vm.filterOriginList,
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item.id,
                                                    attrs: {
                                                      label: item.addressInfo,
                                                      value: item.id,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "y-ml-10 y-fc-4C84FF y-c-p y-w-100",
                                                on: { click: _vm.jumpTb },
                                              },
                                              [_vm._v("添加新发货地址")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass: "y-bk-fff6a0",
                                            staticStyle: { padding: "5px" },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "y-fl-18",
                                                staticStyle: { margin: "0" },
                                              },
                                              [
                                                _vm._v(
                                                  "未找到电子面单发货地址,当前店铺可能未开通电子面单服务或未绑定电子面单帐号。"
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                  ]
                                ),
                                _vm.filterOriginList.length <= 0 && !_vm.loading
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "y-fc-4C84FF y-c-p y-f-r y-fs-14",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { on: { click: _vm.jumpTb } },
                                          [_vm._v("开通电子面单")]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "y-ml-10",
                                            on: {
                                              click: function ($event) {
                                                return _vm.storeAuthorization(
                                                  "ALI_1688"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("绑定电子面单账号")]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "y-ml-10",
                                            on: {
                                              click: function ($event) {
                                                return _vm.howHelpAuth(
                                                  "ALI_1688"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("查看教程")]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _c(
                              "div",
                              { staticClass: "tab-bottom y-fs-14 clearfix" },
                              [
                                _c("p", { staticClass: "y-fc-000 y-fl-18" }, [
                                  _vm._v(
                                    " 您还未绑定任何1688账号，请点击<去绑定>绑定您的1688账号，或点击<查看教程>，按步骤进行操作。 "
                                  ),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "y-fc-4C84FF y-c-p y-f-r" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.storeAuthorization(
                                              "ALI_1688"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("去绑定")]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "y-ml-10",
                                        on: {
                                          click: function ($event) {
                                            return _vm.howHelpAuth("ALI_1688")
                                          },
                                        },
                                      },
                                      [_vm._v("查看教程")]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "菜鸟账号授权", name: "username" } },
                [
                  _vm.activeName == "username"
                    ? [
                        _c("div", { staticClass: "tab-header" }, [
                          _c("div", { staticClass: "left-c" }, [
                            _c("img", {
                              staticClass: "icon-company-box",
                              attrs: {
                                src: require("@/assets/images/ecommercepng/icon_cainiao.png"),
                                alt: "",
                              },
                            }),
                          ]),
                        ]),
                        Object.keys(_vm.cnShopObj).length > 0 ||
                        (Object.keys(_vm.cnShopObj).length <= 0 && _vm.loading)
                          ? _c(
                              "div",
                              { staticClass: "tab-bottom" },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: { label: "菜鸟账号", prop: "shop" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "y-f" },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              placeholder: "请选择账号",
                                            },
                                            on: { change: _vm.changeShop },
                                            model: {
                                              value: _vm.eleBillForm.shop,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.eleBillForm,
                                                  "shop",
                                                  $$v
                                                )
                                              },
                                              expression: "eleBillForm.shop",
                                            },
                                          },
                                          _vm._l(
                                            _vm.cnShopObj,
                                            function (val, key) {
                                              return _c("el-option", {
                                                key: key,
                                                attrs: {
                                                  label: val,
                                                  value: key,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "y-ml-10 y-fc-4C84FF y-c-p y-w-100",
                                            on: { click: _vm.getCNAccessToken },
                                          },
                                          [_vm._v("添加新账号")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "网点发货地址",
                                      prop: "faceId",
                                    },
                                  },
                                  [
                                    _vm.filterOriginList.length > 0 ||
                                    _vm.loading
                                      ? _c(
                                          "div",
                                          { staticClass: "y-f" },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  placeholder: "请选择发货地址",
                                                },
                                                on: {
                                                  change: _vm.changeAddress,
                                                },
                                                model: {
                                                  value: _vm.eleBillForm.faceId,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.eleBillForm,
                                                      "faceId",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "eleBillForm.faceId",
                                                },
                                              },
                                              _vm._l(
                                                _vm.filterOriginList,
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item.id,
                                                    attrs: {
                                                      label: item.addressInfo,
                                                      value: item.id,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "y-ml-10 y-fc-4C84FF y-c-p y-w-100",
                                                on: { click: _vm.jumpCn },
                                              },
                                              [_vm._v("添加新发货地址")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass: "y-bk-fff6a0",
                                            staticStyle: { padding: "5px" },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "y-fl-18",
                                                staticStyle: { margin: "0" },
                                              },
                                              [
                                                _vm._v(
                                                  "未找到电子面单发货地址,当前店铺可能未开通电子面单服务或未绑定电子面单帐号。"
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                  ]
                                ),
                                _vm.filterOriginList.length <= 0 && !_vm.loading
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "y-fc-4C84FF y-c-p y-f-r y-fs-14",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { on: { click: _vm.jumpCn } },
                                          [_vm._v("开通电子面单")]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "y-ml-10",
                                            on: { click: _vm.getCNAccessToken },
                                          },
                                          [_vm._v("绑定电子面单账号")]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "y-ml-10",
                                            on: {
                                              click: function ($event) {
                                                return _vm.howHelpAuth("CN")
                                              },
                                            },
                                          },
                                          [_vm._v("查看教程")]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _c(
                              "div",
                              { staticClass: "tab-bottom y-fs-14 clearfix" },
                              [
                                _c("p", { staticClass: "y-fc-000 y-fl-18" }, [
                                  _vm._v(
                                    " 您还未绑定任何菜鸟账号，请点击<去绑定>绑定您的菜鸟账号，或点击<查看教程>，按步骤进行操作。 "
                                  ),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "y-fc-4C84FF y-c-p y-f-r" },
                                  [
                                    _c(
                                      "span",
                                      { on: { click: _vm.getCNAccessToken } },
                                      [_vm._v("去绑定")]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "y-ml-10",
                                        on: {
                                          click: function ($event) {
                                            return _vm.howHelpAuth("CN")
                                          },
                                        },
                                      },
                                      [_vm._v("查看教程")]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }